export { default as ClaimClosingSlot } from './ClaimClosingSlot';
